import React, { useState } from 'react';
import config from '../config';

const UnsubscribeForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setMessage('Please provide a valid email.');
      return;
    }
    
    setIsSubmitting(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}customer-email/unsubscribe/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Failed to unsubscribe. Please try again.');
      }

      const data = await response.json();
      setIsSubmitting(false);
      setMessage(`You have successfully unsubscribed with the email: ${email}`);
      setEmail('');
    } catch (error) {
      setIsSubmitting(false);
      setMessage(error instanceof Error ? error.message : 'Something went wrong.');
    }
  };


  return (
    <div style={{ maxWidth: 400, margin: '0 auto', padding: '20px', border: '1px solid #ccc', borderRadius: '5px' }}>
      <h2>Unsubscribe</h2>
      <p>
        Unsubscribe? You will not receive any further emails for the current or any future fundraisers.
        If you change your mind in the future, please email our support team from the same email.
      </p>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="email" style={{ display: 'block' }}>Email Address:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Enter your email"
            required
            style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px', border: '1px solid #ccc' }}
          />
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#007BFF',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: isSubmitting ? 'not-allowed' : 'pointer',
          }}
        >
          {isSubmitting ? 'Submitting...' : 'Unsubscribe'}
        </button>
      </form>

      {message && <p style={{ marginTop: '15px', color: isSubmitting ? 'blue' : 'green' }}>{message}</p>}
    </div>
  );
};

export default UnsubscribeForm;
